/**
 * Data Layer
 * ------------------------------------------------------------------------------
 * A script to listen for the custom datalayer events.
 *
 * @namespace DataLayer
 */

import log from 'salvo-lite/log'

class DataLayer {
    constructor (theme, elem) {
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._setListeners()
    }

    _setListeners () {
        window.Frame.EventBus.listen('DataLayer:carRegistration', () => this._dataLayerCarRegistration())
        window.Frame.EventBus.listen('ServicePlan:hasPlan', (success) => this._dataLayerServicePlan(success))
        window.Frame.EventBus.listen('Account:userRegistered', () => this._dataLayerUserRegistration())
        window.Frame.EventBus.listen('DataLayer:removingItem', (item) => this._dataLayerRemovingItem(item))
        window.Frame.EventBus.listen('InstallationDetails:updated', (response) => this._dataLayerInstallationDetails(response))
    }

    _dataLayerCarRegistration () {
        const currentCar = window.Frame.CurrentCarCookie.get()

        window.dataLayer.push({
            event: 'carRegistration',
            model: currentCar.model,
            year: currentCar.year,
            vin: currentCar.vinNumber
        })
    }

    _dataLayerServicePlan (success) {
        const submissionStatus = success ? 'Success' : 'Fail'

        window.dataLayer.push({
            event: 'servicePlan',
            submissionStatus
        })
    }

    _dataLayerUserRegistration () {
        window.dataLayer.push({
            event: 'registration',
            submissionStatus: 'Success'
        })
    }

    _dataLayerRemovingItem (item) {
        window.dataLayer.push({
            event: 'removeFromCart',
            product: item
        })
    }

    _dataLayerInstallationDetails (response) {
        if (response === undefined) return

        window.dataLayer.push({
            event: 'Fitting',
            category: 'Fitting',
            action: (response.checked === true ? 'include' : 'exclude'),
            label: response.installCost
        })
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //     init,
    // })
}

export default DataLayer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DataLayer.js